type StoredUser = Record<string, unknown> & { user_id?: string };

export const addUserToLocalStorage = (user: StoredUser): void => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const removeUserFromLocalStorage = (): void => {
  localStorage.removeItem("user");
};

export const getUserFromLocalStorage = (): StoredUser => {
  const result = localStorage.getItem("user");
  const user = result ? JSON.parse(result) : null;
  return user ?? {};
};

export class LocalStorageService {
  static PORTFOLIO_FILTERS_VISIBILITY = "portfolioFiltersVisibility";

  static getItem<T = unknown>(key: string): null | T {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch {
      return null;
    }
  }

  static removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // Do nothing
    }
  }

  static setItem(key: string, value: unknown): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Do nothing
    }
  }
}
